@import 'close';

.alert {
	margin-bottom: 0;
	border-radius: 0;
	padding: $spacer 0;


	&-dismissible {

		.container {
			position: relative;
			padding-right: 3rem;
		}

		.btn-close {
			padding: 0;
			top: calc((-1 * #{$spacer}) + #{$gutter-sm});
			background-size: 13px 13px;
		}
	}
 
	.btn-close {
		position: absolute;
		top: 0;
		margin-top: 25px;
        fill: $btn-close-color;

        svg {
            fill: $btn-close-color;
        }
	}

	&.has-icon:not(.kdx-cookie) {
		
		> .container {
			padding-left: $spacer * 4;
            display: flex;
			justify-content: center;

			p {
				margin: 25px 10px 25px 40px;
                @include text-size(16);
                @include line-height(22);
				max-width: 735px;
			}

			.btn {
				letter-spacing: normal;
				padding: 0;
				margin-bottom: 25px;
				max-width: 150px;
				margin-top: 20px;
				display: flex;
			}
            
            .alert-link {
                text-decoration: none;
                color: $secondary;
                @include text-size(14);
                @include line-height(30);
                font-weight: 500;
                text-transform: uppercase;
                white-space: nowrap;
				padding-right: 125px;

                svg {
                    max-height: 11px;
                    max-width: 7px;
                    fill: $secondary;
                    margin-left: 8px;
                    transform: translateY(-1px);
                }

                &:hover, &:focus {
                    text-decoration: underline;

                    svg {
                        transform: translate(1px, -1px);
                    }
                }
            }
		}

		.alert-icon {
			display: flex;
			align-items: center;
			position: relative;

			svg {
				@include svg-format(44px, 44px, $primary);
			}
		}
	}

	// Client Scope
	&.kdx-alert {
		background-color: #FFF1D2;
		border: none;
        min-height: 95px;
        width: 100%;

		p {
			margin: 0;
			padding: 0;
			@include line-height(18);
			@include text-size(15);

			strong {
				@include text-size(16);
			}
		}

		strong {
			@include text-size(16);
		}

		[class^="arrow-link"] {
			@include text-size(12);

			.svg-icon {
				margin-right: 0;
			}

			&:last-child {
				margin: 8px 0 0;
			}
		}

		&.has-icon:not(.kdx-cookie) {
			> .container {
				padding-left: $spacer * 5;
			}
		}
	}

	@include media-breakpoint-down(md) {
		&.has-icon:not(.kdx-cookie) {
			> .container {

				p {
					margin: 0 auto;
				}

				.btn {
					display: flex;
					padding: 0;
				}

				.alert-link {
					display: flex;
					padding-right: 0;
					margin-top: 25px;
				}
			}
		}
		&-dismissible {
			.btn-close {
				padding: 0;
				top: calc((-1 * #{$spacer}) + #{$gutter-def});
				right: 35px;
				background-size: 13px 13px;
			}
		}

		&.kdx-alert {
			[class^="arrow-link"]:last-child,
			[class^="arrow-link"] {
				margin: $gutter-sm 0 0;
			}

			&.has-icon:not(.kdx-cookie) {
				> .container {
					padding: 0 35px 16px;
				}

				.alert-icon {
					margin-bottom: 50px;
					margin-left: 0;
					position: relative;
					left: 0;
					height: 45px;
					width: 45px;
				}
			}

			> .container {
				display: flex;
				flex-direction: column;
				padding: 0 35px 16px;
			}
		}
	}
}